import { useState } from 'react';
import './Modal.css';

function SerieModal({ parentSeries, onClose, onSave, token }) {
  const [nom, setNom] = useState('');
  const [parentId, setParentId] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/library/series`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nom,
          parentId: parentId || null,
          description
        })
      });

      if (response.ok) {
        const newSerie = await response.json();
        onSave(newSerie); // Pass back to parent
        onClose();
      } else {
        alert('Erreur lors de la création');
      }
    } catch (err) {
      console.error('Error creating serie:', err);
      alert('Erreur réseau');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Créer une nouvelle série</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Nom de la série *</label>
            <input 
              type="text" 
              value={nom} 
              onChange={(e) => setNom(e.target.value)} 
              required 
              autoFocus
            />
          </div>

          <div className="form-row">
            <label>Série parente (optionnel)</label>
            <select value={parentId} onChange={(e) => setParentId(e.target.value)}>
              <option value="">-- Aucune (série principale) --</option>
              {parentSeries.filter(s => !s.parentId).map(s => (
                <option key={s.id} value={s.id}>{s.nom}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <label>Description</label>
            <textarea 
              value={description} 
              onChange={(e) => setDescription(e.target.value)}
              rows="3"
            />
          </div>

          <div className="modal-buttons">
            <button type="button" onClick={onClose} className="btn-cancel">
              Annuler
            </button>
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Création...' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SerieModal;